export default "__VITE_ASSET__DJOgw_nD__"